import { useEffect, useState } from 'react';
import { Input, Select } from 'antd';
import parsePhoneNumber from 'libphonenumber-js/mobile';

import 'flag-icons/css/flag-icons.min.css';
import styles from './phoneInput.module.scss';

import { countries, CountryNumber } from './countries';

const { Option } = Select;

interface InputProps {
	userDialCode?: string;
	userPhoneNumber?: string;
	onChange: (data: { dialCode: string; number: string; isValid: boolean }) => void;
}

export interface PhoneInputReturn {
	dialCode: string;
	number: string;
	isValid: boolean;
}

function PhoneInputComponent({ onChange, userDialCode, userPhoneNumber }: InputProps) {
	const [selectedCountry, setSelectedCountry] = useState<CountryNumber>({
		isoCode: 'sa',
		dialCode: '+966',
	});

	const [dialCode, setDialCode] = useState<string>(selectedCountry.dialCode);
	const [number, setNumber] = useState<string>('');

	useEffect(() => {
		if (userDialCode) {
			const country = countries.find((el) => el.dialCode === '+' + userDialCode) || selectedCountry;
			setSelectedCountry(country);
			setDialCode('+' + userDialCode);
		}
		if (userPhoneNumber) setNumber(userPhoneNumber);
	}, [userDialCode, userPhoneNumber]);

	const onChangeCountry = (selectedCountryCode: string) => {
		const country = countries.find((el) => el.isoCode === selectedCountryCode) || selectedCountry;
		setSelectedCountry(country);
		setDialCode(country.dialCode);
		onChange({ dialCode: country.dialCode, number: number, isValid: checkPhoneValidation(country.dialCode, number) });
	};

	const onPhoneInput = (e: any) => {
		e.target.value = e.target.value.replace(/[^0-9]/g, '');
		setNumber(e.target.value);
		onChange({ dialCode: dialCode, number: e.target.value, isValid: checkPhoneValidation(dialCode, e.target.value) });
	};

	const onPhoneKeyDown = (e: any) => {
		if (e.which === 38 || e.which === 40) {
			e.preventDefault();
		}
	};

	const selectBefore = (
		<Select value={selectedCountry.isoCode} className={styles.select_element} onChange={onChangeCountry}>
			{countries.map((countryCode) => (
				<Option value={countryCode.isoCode} key={countryCode.isoCode}>
					<span
						className={`fi fi-${countryCode.isoCode} fib`}
						style={{
							marginInlineEnd: 5,
							backgroundSize: 'cover',
							width: 21,
							height: 14,
							borderRadius: 2,
						}}></span>
					{countryCode.isoCode.toUpperCase()}
				</Option>
			))}
		</Select>
	);

	const checkPhoneValidation = (code: string, number: string) => {
		const phoneNumber = parsePhoneNumber(code + number);
		return phoneNumber && phoneNumber.isValid() ? true : false;
	};

	return (
		<Input
			addonBefore={selectBefore}
			className={styles.phoneInput}
			size="large"
			prefix={<span>{selectedCountry.dialCode}</span>}
			onInput={onPhoneInput}
			onKeyDown={onPhoneKeyDown}
			type="number"
			value={number}
			style={{direction:'ltr'}}
		/>
	);
}

export default PhoneInputComponent;
